const CardContent = ({ children }) => <div className="p-4">{children}</div>;

export default CardContent